import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/service/user.service';
import { FormControl, FormGroup } from '@angular/forms';
import { EmployeeService } from '../../shared/service/employee.service';
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-hr-nomination',
  templateUrl: './hr-nomination.component.html',
  styleUrls: ['./hr-nomination.component.css']
})
export class HrNominationComponent implements OnInit {
  permission: any;
  showDetails = false;
  NominationForm: FormGroup;
  AwardTypeVal: string = null;
  AwardVal: string = null;
  QuarterVal: string = null;
  offshoreAmt: number;
  onshoreAmt: number;
  awardDetails: any;
  error: any;
  constructor(public _userService: UserService, private emp_Svc: EmployeeService, private toastr: ToastrService,) {
    this.FormInitialization();
  }

  ngOnInit() {
    this.permission = this._userService.userInfo.permissions.find(
      (i) => i.Menu === "Master"
    );
  }

  toggleDetails() {
    this.showDetails = true;
  }

  GetEmployeeAwardDetails() {
    var empCode = 2416;
    this.awardDetails = [];
    this.emp_Svc.getEmployeeAwardDetails(empCode).subscribe(
      (data: any) => {
        if (data != null && data.length != 0) {
          this.awardDetails = data;
        } else {
          this.toastr.warning("No awards for the employee");
        }
      },
      (error) => (this.error = error)
    );
  }

  FormInitialization() {
    this.NominationForm = new FormGroup({
      AwardType: new FormControl(),
      Award: new FormControl(),
      Quarter: new FormControl(),
      OffshoreAmount: new FormControl(),
      OnshoreAmount:new FormControl()
    });
  }
}
